/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeFaqDetails } from './ChallengeFaqDetails';
import {
    ChallengeFaqDetailsFromJSON,
    ChallengeFaqDetailsFromJSONTyped,
    ChallengeFaqDetailsToJSON,
    ChallengeFaqDetailsToJSONTyped,
} from './ChallengeFaqDetails';
import type { ChallengeGrandPrize } from './ChallengeGrandPrize';
import {
    ChallengeGrandPrizeFromJSON,
    ChallengeGrandPrizeFromJSONTyped,
    ChallengeGrandPrizeToJSON,
    ChallengeGrandPrizeToJSONTyped,
} from './ChallengeGrandPrize';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { ChallengePromotionsSectionConfig } from './ChallengePromotionsSectionConfig';
import {
    ChallengePromotionsSectionConfigFromJSON,
    ChallengePromotionsSectionConfigFromJSONTyped,
    ChallengePromotionsSectionConfigToJSON,
    ChallengePromotionsSectionConfigToJSONTyped,
} from './ChallengePromotionsSectionConfig';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { ChallengeSectionStyleConfig } from './ChallengeSectionStyleConfig';
import {
    ChallengeSectionStyleConfigFromJSON,
    ChallengeSectionStyleConfigFromJSONTyped,
    ChallengeSectionStyleConfigToJSON,
    ChallengeSectionStyleConfigToJSONTyped,
} from './ChallengeSectionStyleConfig';
import type { ChallengeSegment } from './ChallengeSegment';
import {
    ChallengeSegmentFromJSON,
    ChallengeSegmentFromJSONTyped,
    ChallengeSegmentToJSON,
    ChallengeSegmentToJSONTyped,
} from './ChallengeSegment';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { EligibilityConfig } from './EligibilityConfig';
import {
    EligibilityConfigFromJSON,
    EligibilityConfigFromJSONTyped,
    EligibilityConfigToJSON,
    EligibilityConfigToJSONTyped,
} from './EligibilityConfig';
import type { ChallengeEmailConfig } from './ChallengeEmailConfig';
import {
    ChallengeEmailConfigFromJSON,
    ChallengeEmailConfigFromJSONTyped,
    ChallengeEmailConfigToJSON,
    ChallengeEmailConfigToJSONTyped,
} from './ChallengeEmailConfig';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { ChallengeVideoSection } from './ChallengeVideoSection';
import {
    ChallengeVideoSectionFromJSON,
    ChallengeVideoSectionFromJSONTyped,
    ChallengeVideoSectionToJSON,
    ChallengeVideoSectionToJSONTyped,
} from './ChallengeVideoSection';
import type { ChallengeEligibilityCheckbox } from './ChallengeEligibilityCheckbox';
import {
    ChallengeEligibilityCheckboxFromJSON,
    ChallengeEligibilityCheckboxFromJSONTyped,
    ChallengeEligibilityCheckboxToJSON,
    ChallengeEligibilityCheckboxToJSONTyped,
} from './ChallengeEligibilityCheckbox';
import type { SignupMethod } from './SignupMethod';
import {
    SignupMethodFromJSON,
    SignupMethodFromJSONTyped,
    SignupMethodToJSON,
    SignupMethodToJSONTyped,
} from './SignupMethod';
import type { ChallengeContentSection } from './ChallengeContentSection';
import {
    ChallengeContentSectionFromJSON,
    ChallengeContentSectionFromJSONTyped,
    ChallengeContentSectionToJSON,
    ChallengeContentSectionToJSONTyped,
} from './ChallengeContentSection';
import type { ChallengeOnboarding } from './ChallengeOnboarding';
import {
    ChallengeOnboardingFromJSON,
    ChallengeOnboardingFromJSONTyped,
    ChallengeOnboardingToJSON,
    ChallengeOnboardingToJSONTyped,
} from './ChallengeOnboarding';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';
import type { ChallengePageMode } from './ChallengePageMode';
import {
    ChallengePageModeFromJSON,
    ChallengePageModeFromJSONTyped,
    ChallengePageModeToJSON,
    ChallengePageModeToJSONTyped,
} from './ChallengePageMode';
import type { ChallengeCommunityGoal } from './ChallengeCommunityGoal';
import {
    ChallengeCommunityGoalFromJSON,
    ChallengeCommunityGoalFromJSONTyped,
    ChallengeCommunityGoalToJSON,
    ChallengeCommunityGoalToJSONTyped,
} from './ChallengeCommunityGoal';

/**
 * 
 * @export
 * @interface ChallengeBody
 */
export interface ChallengeBody {
    /**
     * The title of the challenge
     * @type {string}
     * @memberof ChallengeBody
     */
    name: string;
    /**
     * The title of the challenge on the card
     * @type {string}
     * @memberof ChallengeBody
     */
    cardTitle?: string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof ChallengeBody
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeBody
     */
    backgroundImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeBody
     */
    backgroundImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeBody
     */
    brandLogo?: string;
    /**
     * Hex color code for the brand
     * @type {string}
     * @memberof ChallengeBody
     */
    brandColor?: string;
    /**
     * Hex color code for the brand
     * @type {string}
     * @memberof ChallengeBody
     */
    textColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeBody
     */
    disclaimerTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeBody
     */
    disclaimerDescription?: string;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof ChallengeBody
     */
    isActive?: boolean;
    /**
     * Whether the challenge is only available to admins.
     * @type {boolean}
     * @memberof ChallengeBody
     */
    isAdminOnly?: boolean;
    /**
     * Whether to show this challenge as a promo card on CockpitV3 and other discovery surfaces.
     * @type {boolean}
     * @memberof ChallengeBody
     */
    showPromoCard?: boolean;
    /**
     * Terms and conditions URL
     * @type {string}
     * @memberof ChallengeBody
     */
    termsUrl?: string;
    /**
     * Rich text (HTML) terms and rules content for inline display
     * @type {string}
     * @memberof ChallengeBody
     */
    termsContent?: string;
    /**
     * prize pool feature image
     * @type {string}
     * @memberof ChallengeBody
     */
    prizePoolFeatureImage?: string;
    /**
     * font size of the challenge title
     * @type {number}
     * @memberof ChallengeBody
     */
    titleFontSize?: number;
    /**
     * 
     * @type {Array<ChallengeSegment>}
     * @memberof ChallengeBody
     */
    segments?: Array<ChallengeSegment>;
    /**
     * 
     * @type {ChallengeOnboarding}
     * @memberof ChallengeBody
     */
    onboardingSection?: ChallengeOnboarding;
    /**
     * 
     * @type {Array<ChallengeFaqDetails>}
     * @memberof ChallengeBody
     */
    faqs?: Array<ChallengeFaqDetails>;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ChallengeBody
     */
    challengeType?: ChallengeType;
    /**
     * 
     * @type {ChallengePageMode}
     * @memberof ChallengeBody
     */
    pageMode?: ChallengePageMode;
    /**
     * URL-friendly identifier for the challenge
     * @type {string}
     * @memberof ChallengeBody
     */
    slug?: string;
    /**
     * External URL for challenge landing page. When set, promotional cards open this URL in a new window.
     * @type {string}
     * @memberof ChallengeBody
     */
    landingPageUrl?: string;
    /**
     * Whether the challenge requires DevourPlay app
     * @type {boolean}
     * @memberof ChallengeBody
     */
    requiresDevourPlay?: boolean;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof ChallengeBody
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof ChallengeBody
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof ChallengeBody
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {ChallengeVideoSection}
     * @memberof ChallengeBody
     */
    videoSection?: ChallengeVideoSection;
    /**
     * 
     * @type {Array<ChallengeContentSection>}
     * @memberof ChallengeBody
     */
    contentSections?: Array<ChallengeContentSection>;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof ChallengeBody
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeBody
     */
    onboardingStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeBody
     */
    prizeSectionStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeBody
     */
    entriesColumnStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeBody
     */
    questsStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeBody
     */
    faqStyles?: ChallengeSectionStyleConfig;
    /**
     * Custom content for the left side of FAQ section
     * @type {string}
     * @memberof ChallengeBody
     */
    faqLeftContent?: string;
    /**
     * Custom HTML to inject into the page head
     * @type {string}
     * @memberof ChallengeBody
     */
    customHeadHtml?: string;
    /**
     * Custom HTML to inject into the page body
     * @type {string}
     * @memberof ChallengeBody
     */
    customBodyHtml?: string;
    /**
     * 
     * @type {ChallengePromotionsSectionConfig}
     * @memberof ChallengeBody
     */
    promotionsSection?: ChallengePromotionsSectionConfig;
    /**
     * 
     * @type {PageSeo}
     * @memberof ChallengeBody
     */
    seo?: PageSeo;
    /**
     * Asset ID for default user avatar
     * @type {string}
     * @memberof ChallengeBody
     */
    defaultAvatarImageId?: string;
    /**
     * 
     * @type {ChallengeEmailConfig}
     * @memberof ChallengeBody
     */
    emailConfig?: ChallengeEmailConfig;
    /**
     * 
     * @type {ChallengeGrandPrize}
     * @memberof ChallengeBody
     */
    grandPrize?: ChallengeGrandPrize;
    /**
     * 
     * @type {ChallengeCommunityGoal}
     * @memberof ChallengeBody
     */
    communityGoal?: ChallengeCommunityGoal;
    /**
     * ID of the Brand to associate with this challenge
     * @type {string}
     * @memberof ChallengeBody
     */
    brandId?: string;
    /**
     * Optional https webhook URL for challenge-specific operational alerts (Slack incoming webhook, Discord webhook, or internal endpoint). **Write-only** — the model marks the property `select:false` and `ChallengeResponse` structurally Omit's it; no GET path returns the stored value. Admin forms must re-submit the value on every UPDATE if it should be preserved. Validator enforces https + no embedded credentials.
     * @type {string}
     * @memberof ChallengeBody
     */
    notificationWebhookUrl?: string;
    /**
     * Optional GamificationModel ID (e.g. WHEEL_SPIN) wired to this challenge
     * @type {string}
     * @memberof ChallengeBody
     */
    gamificationModelId?: string;
    /**
     * Optional per-challenge eligibility checkboxes rendered alongside 18+ and Terms in the sign-in modal. Empty/omitted means no extra checkboxes.
     * @type {Array<ChallengeEligibilityCheckbox>}
     * @memberof ChallengeBody
     */
    eligibilityCheckboxes?: Array<ChallengeEligibilityCheckbox>;
    /**
     * 
     * @type {EligibilityConfig}
     * @memberof ChallengeBody
     */
    eligibilityConfig?: EligibilityConfig;
    /**
     * Optional uppercase prefix for challenge-scoped referral codes (e.g. "RTTR" → RTTR12345).
     * @type {string}
     * @memberof ChallengeBody
     */
    referralCodePrefix?: string;
    /**
     * Optional whitelist of signup methods rendered in the ChallengeLoginModal. Empty/undefined = legacy behavior (all methods shown). When set, ChallengeLoginModal filters the social provider list and conditionally renders the email-only form. RTTR uses ["EMAIL"] to force email-only registration so Realm UUID linkage uses the same email as the Realm account.
     * @type {Array<SignupMethod>}
     * @memberof ChallengeBody
     */
    allowedSignupMethods?: Array<SignupMethod>;
    /**
     * Cumulative-point thresholds (across all activations + segments) at which the user is granted a wheel spin via gamificationModelId. Idempotent — each threshold awarded at most once per user. Empty/undefined disables milestone-triggered spins; the model's stored default is an empty array (no platform-wide thresholds).
     * @type {Array<number>}
     * @memberof ChallengeBody
     */
    wheelMilestoneThresholds?: Array<number>;
}



/**
 * Check if a given object implements the ChallengeBody interface.
 */
export function instanceOfChallengeBody(value: object): value is ChallengeBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ChallengeBodyFromJSON(json: any): ChallengeBody {
    return ChallengeBodyFromJSONTyped(json, false);
}

export function ChallengeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'cardTitle': json['cardTitle'] == null ? undefined : json['cardTitle'],
        'description': json['description'],
        'backgroundImageLarge': json['backgroundImageLarge'] == null ? undefined : json['backgroundImageLarge'],
        'backgroundImageSmall': json['backgroundImageSmall'] == null ? undefined : json['backgroundImageSmall'],
        'brandLogo': json['brandLogo'] == null ? undefined : json['brandLogo'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'disclaimerTitle': json['disclaimerTitle'] == null ? undefined : json['disclaimerTitle'],
        'disclaimerDescription': json['disclaimerDescription'] == null ? undefined : json['disclaimerDescription'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isAdminOnly': json['isAdminOnly'] == null ? undefined : json['isAdminOnly'],
        'showPromoCard': json['showPromoCard'] == null ? undefined : json['showPromoCard'],
        'termsUrl': json['termsUrl'] == null ? undefined : json['termsUrl'],
        'termsContent': json['termsContent'] == null ? undefined : json['termsContent'],
        'prizePoolFeatureImage': json['prizePoolFeatureImage'] == null ? undefined : json['prizePoolFeatureImage'],
        'titleFontSize': json['titleFontSize'] == null ? undefined : json['titleFontSize'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ChallengeSegmentFromJSON)),
        'onboardingSection': json['onboardingSection'] == null ? undefined : ChallengeOnboardingFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(ChallengeFaqDetailsFromJSON)),
        'challengeType': json['challengeType'] == null ? undefined : ChallengeTypeFromJSON(json['challengeType']),
        'pageMode': json['pageMode'] == null ? undefined : ChallengePageModeFromJSON(json['pageMode']),
        'slug': json['slug'] == null ? undefined : json['slug'],
        'landingPageUrl': json['landingPageUrl'] == null ? undefined : json['landingPageUrl'],
        'requiresDevourPlay': json['requiresDevourPlay'] == null ? undefined : json['requiresDevourPlay'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'videoSection': json['videoSection'] == null ? undefined : ChallengeVideoSectionFromJSON(json['videoSection']),
        'contentSections': json['contentSections'] == null ? undefined : ((json['contentSections'] as Array<any>).map(ChallengeContentSectionFromJSON)),
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'onboardingStyles': json['onboardingStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['onboardingStyles']),
        'prizeSectionStyles': json['prizeSectionStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['prizeSectionStyles']),
        'entriesColumnStyles': json['entriesColumnStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['entriesColumnStyles']),
        'questsStyles': json['questsStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['questsStyles']),
        'faqStyles': json['faqStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['faqStyles']),
        'faqLeftContent': json['faqLeftContent'] == null ? undefined : json['faqLeftContent'],
        'customHeadHtml': json['customHeadHtml'] == null ? undefined : json['customHeadHtml'],
        'customBodyHtml': json['customBodyHtml'] == null ? undefined : json['customBodyHtml'],
        'promotionsSection': json['promotionsSection'] == null ? undefined : ChallengePromotionsSectionConfigFromJSON(json['promotionsSection']),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'defaultAvatarImageId': json['defaultAvatarImageId'] == null ? undefined : json['defaultAvatarImageId'],
        'emailConfig': json['emailConfig'] == null ? undefined : ChallengeEmailConfigFromJSON(json['emailConfig']),
        'grandPrize': json['grandPrize'] == null ? undefined : ChallengeGrandPrizeFromJSON(json['grandPrize']),
        'communityGoal': json['communityGoal'] == null ? undefined : ChallengeCommunityGoalFromJSON(json['communityGoal']),
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'notificationWebhookUrl': json['notificationWebhookUrl'] == null ? undefined : json['notificationWebhookUrl'],
        'gamificationModelId': json['gamificationModelId'] == null ? undefined : json['gamificationModelId'],
        'eligibilityCheckboxes': json['eligibilityCheckboxes'] == null ? undefined : ((json['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxFromJSON)),
        'eligibilityConfig': json['eligibilityConfig'] == null ? undefined : EligibilityConfigFromJSON(json['eligibilityConfig']),
        'referralCodePrefix': json['referralCodePrefix'] == null ? undefined : json['referralCodePrefix'],
        'allowedSignupMethods': json['allowedSignupMethods'] == null ? undefined : ((json['allowedSignupMethods'] as Array<any>).map(SignupMethodFromJSON)),
        'wheelMilestoneThresholds': json['wheelMilestoneThresholds'] == null ? undefined : json['wheelMilestoneThresholds'],
    };
}

export function ChallengeBodyToJSON(json: any): ChallengeBody {
    return ChallengeBodyToJSONTyped(json, false);
}

export function ChallengeBodyToJSONTyped(value?: ChallengeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'cardTitle': value['cardTitle'],
        'description': value['description'],
        'backgroundImageLarge': value['backgroundImageLarge'],
        'backgroundImageSmall': value['backgroundImageSmall'],
        'brandLogo': value['brandLogo'],
        'brandColor': value['brandColor'],
        'textColor': value['textColor'],
        'disclaimerTitle': value['disclaimerTitle'],
        'disclaimerDescription': value['disclaimerDescription'],
        'isActive': value['isActive'],
        'isAdminOnly': value['isAdminOnly'],
        'showPromoCard': value['showPromoCard'],
        'termsUrl': value['termsUrl'],
        'termsContent': value['termsContent'],
        'prizePoolFeatureImage': value['prizePoolFeatureImage'],
        'titleFontSize': value['titleFontSize'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ChallengeSegmentToJSON)),
        'onboardingSection': ChallengeOnboardingToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(ChallengeFaqDetailsToJSON)),
        'challengeType': ChallengeTypeToJSON(value['challengeType']),
        'pageMode': ChallengePageModeToJSON(value['pageMode']),
        'slug': value['slug'],
        'landingPageUrl': value['landingPageUrl'],
        'requiresDevourPlay': value['requiresDevourPlay'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'videoSection': ChallengeVideoSectionToJSON(value['videoSection']),
        'contentSections': value['contentSections'] == null ? undefined : ((value['contentSections'] as Array<any>).map(ChallengeContentSectionToJSON)),
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'onboardingStyles': ChallengeSectionStyleConfigToJSON(value['onboardingStyles']),
        'prizeSectionStyles': ChallengeSectionStyleConfigToJSON(value['prizeSectionStyles']),
        'entriesColumnStyles': ChallengeSectionStyleConfigToJSON(value['entriesColumnStyles']),
        'questsStyles': ChallengeSectionStyleConfigToJSON(value['questsStyles']),
        'faqStyles': ChallengeSectionStyleConfigToJSON(value['faqStyles']),
        'faqLeftContent': value['faqLeftContent'],
        'customHeadHtml': value['customHeadHtml'],
        'customBodyHtml': value['customBodyHtml'],
        'promotionsSection': ChallengePromotionsSectionConfigToJSON(value['promotionsSection']),
        'seo': PageSeoToJSON(value['seo']),
        'defaultAvatarImageId': value['defaultAvatarImageId'],
        'emailConfig': ChallengeEmailConfigToJSON(value['emailConfig']),
        'grandPrize': ChallengeGrandPrizeToJSON(value['grandPrize']),
        'communityGoal': ChallengeCommunityGoalToJSON(value['communityGoal']),
        'brandId': value['brandId'],
        'notificationWebhookUrl': value['notificationWebhookUrl'],
        'gamificationModelId': value['gamificationModelId'],
        'eligibilityCheckboxes': value['eligibilityCheckboxes'] == null ? undefined : ((value['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxToJSON)),
        'eligibilityConfig': EligibilityConfigToJSON(value['eligibilityConfig']),
        'referralCodePrefix': value['referralCodePrefix'],
        'allowedSignupMethods': value['allowedSignupMethods'] == null ? undefined : ((value['allowedSignupMethods'] as Array<any>).map(SignupMethodToJSON)),
        'wheelMilestoneThresholds': value['wheelMilestoneThresholds'],
    };
}

